<template>
  <div class="task-recycle-bin-container">
    <Banner></Banner>
    <div class="tabs-box">
      <div class="batch-wrap btn-active" v-if="isShowBatchBtn" @click="handleBatch">
        <i class="icon iconfont iconicon_batch_selection"></i>
        <span>批量选择</span>
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="任务" name="task">
          <Task
            ref="task"
            :projectId="projectId"
            :batch="batch"
            @handleExit="handleExit"
            @handleGetList="handleGetList"
          ></Task>
        </el-tab-pane>
        <el-tab-pane label="任务清单" name="taskList">
          <Task-list
            ref="taskList"
            :projectId="projectId"
            :batch="taskListBatch"
            @handleExit="handleTaskListExit"
            @handleGetList="handleGetList"
          ></Task-list>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import Task from './components/task.vue'
import TaskList from './components/taskList.vue'
import Banner from '@/components/banner/'
export default {
  components: {
    Task,
    TaskList,
    Banner
  },
  computed:{
    // 是否展示“批量选择”按钮
    isShowBatchBtn() {
      return this.activeName === 'task' ? this.taskNum : this.taskListNum
    }
  },
  data() {
    return {
      activeName: 'task',
      projectId: null,
      taskNum: 0,
      taskListNum: 0,
      batch: false,
      taskListBatch: false
    }
  },
  created() {
    let {  query } = this.$route
    this.projectId = Number(query.projectId)
  },
  methods: {
    // 批量选择按钮
    handleBatch() {
      if (this.activeName === 'task') {
        this.batch = true
      } else if (this.activeName === 'taskList') {
        this.taskListBatch = true
      }
    },
    // 首次获取到列表的数量
    handleGetList(type, num) {
      this[type] = num
    },
    // 退出批量选择模式
    handleExit() {
      this.batch = false
    },
    // 退出任务清单的批量选择模式
    handleTaskListExit() {
      this.taskListBatch = false
    }
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/mixin.scss";
.task-recycle-bin-container {
  height: 100%;
  .tabs-box {
    height: 100%;
    position: relative;
    .batch-wrap {
      cursor: pointer;
      position: absolute;
      right: 16px;
      top: 8px;
      z-index: 99;
      display: flex;
      align-items: center;
      @include fontColorOpacity(.6);
      i {
        font-size: 14px;
        margin-right: 4px;
      }
      span {
        font-size: 14px;
      }
    }
    .el-tabs__header {
      padding-left: 32px;
      box-sizing: border-box;
      box-shadow: 0px 2px 8px 0px rgba(32, 32, 32, .16);
    }
    .el-tabs {
      height: 100%;
      display: flex;
      flex-direction: column;
    }
    .el-tabs__content {
      height: 0;
      flex: 1;
      overflow: auto;
    }
    .el-tab-pane {
      height: 100%;
    }
    .recycle-bin-list-container {
      width: 1015px;
      height: 100%;
      margin: 0 auto;
      padding-top: 22px;
      box-sizing: border-box;
      font-size: 14px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      .list-item {
        position: relative;
        display: flex;
        align-items: center;
        width: 100%;
        height: 48px;
        line-height: 48px;
        cursor: pointer;
        padding: 0 48px;
        box-sizing: border-box;
        @include fontColorOpacity(.8);
        &:hover {
          @include bgColorOpacity(.04);
          border-radius: 4px;
          .name .recover {
            visibility: visible;
          }
        }
        &.is-batch {
          &:hover {
            .name .recover {
              visibility: hidden;
            }
          }
        }
        // &.is-chos {
        //   background: rgba(38,130,255,0.08);
        //   border: 1px solid #2682FF;
        //   &+ .is-chos {
        //     border-top: none;
        //   }
        // }
        // &.clear-border-b {
        //   border-bottom: none;
        // }
        &.list-header {
          height: 48px;
          line-height: 48px;
          padding: 0 48px;
          margin-bottom: 4px;
          @include fontColorOpacity(.6);
          border-bottom: 1px solid rgba(32, 32, 32, .08);;
          cursor: auto;
          position: sticky;
          top: 0;
          z-index: 999;
          background: #fff;
          &:hover {
            background: #fff;
          }
          .name {

          @include fontColorOpacity(.6);
          }
        }
        .el-checkbox {
          position: absolute;
          left: 16px;
        }
        .name {
          width: 658px;
          display: flex;
          align-items: center;
          @include fontColorOpacity(1);
          .recover {
            visibility: hidden;
            margin-left: 32px;
            &:hover {
              color: #2682FF;
            }
            i {
              font-size: 12px;
              margin-right: 7px;
            }
            span {
              font-size: 14px;
            }
          }
        }
        .user {
          width: 110px;
        }
        .date {
          flex: 1;
        }

        // .sub-list {
        //   width: 100%;
        //   .sub-list-item {
        //     display: flex;
        //     align-items: center;
        //     width: 100%;
        //     height: 48px;
        //     line-height: 48px;
        //     cursor: pointer;
        //     padding: 0 48px;
        //     box-sizing: border-box;
        //     &:hover {
        //       background: rgba(32, 32, 32, 0.04);
        //       border-radius: 4px;
        //       .name .recover {
        //         visibility: visible;
        //       }
        //     }
        //     &.is-batch {
        //       &:hover {
        //         .name .recover {
        //           visibility: hidden;
        //         }
        //       }
        //     }
        //     &.is-chos {
        //       background: rgba(38,130,255,0.08);
        //       border: 1px solid #2682FF;
        //       &+ .is-chos {
        //         border-top: none;
        //       }
        //     }
        //     &.clear-border-b {
        //       border-bottom: none;
        //     }
        //   }
        // }
      }
      .loading-box {
        padding: 0 48px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .task-list {
        position: relative;
        overflow-y: scroll;
        height: 0;
        flex: 1;
        .nothing-box {
          top: 300px;
          transform: translate(-50%, 0);
        }
        .check-all-icon {
          height: 16px;
          line-height: 16px;
          position: absolute;
          left: 16px;
        }
      }
      .batch-box-wrap {
        position: fixed;
        left: 50%;
        bottom: 40px;
        transform: translate(-50%, 0);
        width: 321px;
        height: 54px;
        background: #fff;
        box-shadow: 0px 4px 16px 0px rgba(32,32,32,0.16);
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 24px;
        box-sizing: border-box;
        .num {
          @include fontColorOpacity(.6);
        }
        .batch-item {
          display: flex;
          align-items: center;
          cursor: pointer;
          &:hover {
            color: #2682FF;
          }
          i {
            font-size: 12px;
            margin-right: 9px;
          }
          span {
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>
